"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAgreements = exports.validateSalaryDeductionAgreement = exports.validateBankingDocumentsStep = exports.validateDocuments = exports.validateBankingDetails = exports.validateEmploymentPaypointStep = exports.validatePaypointDetails = exports.validateEmploymentDetails = exports.validateLoanAffordabilityStep = exports.validateAffordabilityDetails = exports.validateLoanDetails = void 0;
var validation_messages_1 = require("../constants/validation-messages");
var input_validators_1 = require("./input-validators");
var phone_utils_1 = require("./phone-utils");
// Client update: existing loan question removed so validation no longer checks it.
// Validation for Loan Details (Step 0 - Loan Setup)
var validateLoanDetails = function (selectedBranch, loanTerm, loanAmount, loanAmountLimits, formatCurrency, selectedProviderId) {
    var errors = {};
    // Provider validation
    if (selectedProviderId !== undefined && !selectedProviderId) {
        errors.provider = validation_messages_1.LOAN_SETUP_ERRORS.PROVIDER_REQUIRED;
    }
    // Branch validation - use 'branch' key to match step renderer expectations
    if (!selectedBranch) {
        errors.branch = validation_messages_1.LOAN_SETUP_ERRORS.BRANCH_REQUIRED;
    }
    // Loan term validation
    if (!loanTerm) {
        errors.loanTerm = validation_messages_1.LOAN_SETUP_ERRORS.LOAN_TERM_REQUIRED;
    }
    // Loan amount validation
    var loanAmountValue = parseFloat(loanAmount);
    if (!loanAmount.trim() || isNaN(loanAmountValue)) {
        errors.loanAmount = validation_messages_1.LOAN_SETUP_ERRORS.LOAN_AMOUNT_REQUIRED;
    }
    else if (loanAmountValue < loanAmountLimits.MIN) {
        errors.loanAmount = validation_messages_1.LOAN_SETUP_ERRORS.LOAN_AMOUNT_MIN(formatCurrency(loanAmountLimits.MIN));
    }
    else if (loanAmountValue > loanAmountLimits.MAX) {
        errors.loanAmount = validation_messages_1.LOAN_SETUP_ERRORS.LOAN_AMOUNT_MAX(formatCurrency(loanAmountLimits.MAX));
    }
    return errors;
};
exports.validateLoanDetails = validateLoanDetails;
// Validation for Affordability (Step 2 - Part 2)
var validateAffordabilityDetails = function (housingExpense, transportExpense, educationExpense, electricityExpense, groceriesExpense, accountPayments, fixedDeductions, otherObligations, visibleMonthlyExpenses) {
    var errors = {};
    var shouldValidate = function (key) {
        return visibleMonthlyExpenses ? visibleMonthlyExpenses[key] !== false : true;
    };
    // Monthly Expenses validation
    if (shouldValidate("housing") &&
        (!housingExpense.trim() || parseFloat(housingExpense) < 0)) {
        errors.housingExpense = validation_messages_1.FINANCIAL_ERRORS.HOUSING_EXPENSE_REQUIRED;
    }
    else if (shouldValidate("housing") && !(0, input_validators_1.isValidDecimal)(housingExpense, 2)) {
        errors.housingExpense = validation_messages_1.FINANCIAL_ERRORS.HOUSING_EXPENSE_INVALID;
    }
    if (shouldValidate("transport") &&
        (!transportExpense.trim() || parseFloat(transportExpense) < 0)) {
        errors.transportExpense = validation_messages_1.FINANCIAL_ERRORS.TRANSPORT_EXPENSE_REQUIRED;
    }
    else if (shouldValidate("transport") &&
        !(0, input_validators_1.isValidDecimal)(transportExpense, 2)) {
        errors.transportExpense = validation_messages_1.FINANCIAL_ERRORS.TRANSPORT_EXPENSE_INVALID;
    }
    if (shouldValidate("education") &&
        (!educationExpense.trim() || parseFloat(educationExpense) < 0)) {
        errors.educationExpense = validation_messages_1.FINANCIAL_ERRORS.EDUCATION_EXPENSE_REQUIRED;
    }
    else if (shouldValidate("education") &&
        !(0, input_validators_1.isValidDecimal)(educationExpense, 2)) {
        errors.educationExpense = validation_messages_1.FINANCIAL_ERRORS.EDUCATION_EXPENSE_INVALID;
    }
    if (shouldValidate("electricity") &&
        (!electricityExpense.trim() || parseFloat(electricityExpense) < 0)) {
        errors.electricityExpense = validation_messages_1.FINANCIAL_ERRORS.ELECTRICITY_EXPENSE_REQUIRED;
    }
    else if (shouldValidate("electricity") &&
        !(0, input_validators_1.isValidDecimal)(electricityExpense, 2)) {
        errors.electricityExpense = validation_messages_1.FINANCIAL_ERRORS.ELECTRICITY_EXPENSE_INVALID;
    }
    if (shouldValidate("groceries") &&
        (!groceriesExpense.trim() || parseFloat(groceriesExpense) < 0)) {
        errors.groceriesExpense = validation_messages_1.FINANCIAL_ERRORS.GROCERIES_EXPENSE_REQUIRED;
    }
    else if (shouldValidate("groceries") &&
        !(0, input_validators_1.isValidDecimal)(groceriesExpense, 2)) {
        errors.groceriesExpense = validation_messages_1.FINANCIAL_ERRORS.GROCERIES_EXPENSE_INVALID;
    }
    // Account Payments validation
    accountPayments.forEach(function (payment, index) {
        if (!payment.description.trim()) {
            errors["accountPayment_desc_".concat(index)] =
                validation_messages_1.FINANCIAL_ERRORS.ACCOUNT_PAYMENT_DESC_REQUIRED;
        }
        if (!payment.amount.trim() || parseFloat(payment.amount) < 0) {
            errors["accountPayment_amt_".concat(index)] =
                validation_messages_1.FINANCIAL_ERRORS.ACCOUNT_PAYMENT_AMT_REQUIRED;
        }
        else if (!(0, input_validators_1.isValidDecimal)(payment.amount, 2)) {
            errors["accountPayment_amt_".concat(index)] =
                validation_messages_1.FINANCIAL_ERRORS.ACCOUNT_PAYMENT_AMT_INVALID;
        }
    });
    // Fixed Deductions validation
    fixedDeductions.forEach(function (deduction, index) {
        if (!deduction.description.trim()) {
            errors["fixedDeduction_desc_".concat(index)] =
                validation_messages_1.FINANCIAL_ERRORS.DEDUCTION_DESC_REQUIRED;
        }
        if (!deduction.amount.trim() || parseFloat(deduction.amount) < 0) {
            errors["fixedDeduction_amt_".concat(index)] =
                validation_messages_1.FINANCIAL_ERRORS.DEDUCTION_AMT_REQUIRED;
        }
        else if (!(0, input_validators_1.isValidDecimal)(deduction.amount, 2)) {
            errors["fixedDeduction_amt_".concat(index)] =
                validation_messages_1.FINANCIAL_ERRORS.DEDUCTION_AMT_INVALID;
        }
    });
    // Other Obligations validation
    otherObligations.forEach(function (obligation, index) {
        if (!obligation.description.trim()) {
            errors["otherObligation_desc_".concat(index)] =
                validation_messages_1.FINANCIAL_ERRORS.OBLIGATION_DESC_REQUIRED;
        }
        if (!obligation.amount.trim() || parseFloat(obligation.amount) < 0) {
            errors["otherObligation_amt_".concat(index)] =
                validation_messages_1.FINANCIAL_ERRORS.OBLIGATION_AMT_REQUIRED;
        }
        else if (!(0, input_validators_1.isValidDecimal)(obligation.amount, 2)) {
            errors["otherObligation_amt_".concat(index)] =
                validation_messages_1.FINANCIAL_ERRORS.OBLIGATION_AMT_INVALID;
        }
    });
    return errors;
};
exports.validateAffordabilityDetails = validateAffordabilityDetails;
// Combined validation for Step 7: Financial Details (Affordability only, NO loan validation)
// Note: Loan amount/term are validated at Step 0 and should not be re-validated here
var validateLoanAffordabilityStep = function (selectedBranch, loanTerm, loanAmount, loanAmountLimits, formatCurrency, housingExpense, transportExpense, educationExpense, electricityExpense, groceriesExpense, accountPayments, fixedDeductions, otherObligations, visibleMonthlyExpenses, payFrequency, payDate) {
    // DO NOT validate loan details here - they're already validated at Step 0
    // Only validate affordability/financial details for Step 7
    var affordabilityErrors = (0, exports.validateAffordabilityDetails)(housingExpense, transportExpense, educationExpense, electricityExpense, groceriesExpense, accountPayments, fixedDeductions, otherObligations, visibleMonthlyExpenses);
    // Pay Frequency and Pay Date validation
    var payErrors = {};
    if (payFrequency && !payFrequency.trim()) {
        payErrors.payFrequency = validation_messages_1.FINANCIAL_ERRORS.PAY_FREQUENCY_REQUIRED;
    }
    if (payDate !== undefined) {
        if (!payDate.trim()) {
            payErrors.payDate = validation_messages_1.FINANCIAL_ERRORS.PAY_DATE_REQUIRED;
        }
        else {
            var payDayNumber = parseInt(payDate, 10);
            if (isNaN(payDayNumber)) {
                payErrors.payDate = validation_messages_1.FINANCIAL_ERRORS.PAY_DATE_INVALID;
            }
            else if (payDayNumber < 1 || payDayNumber > 31) {
                payErrors.payDate = validation_messages_1.FINANCIAL_ERRORS.PAY_DATE_RANGE;
            }
        }
    }
    return __assign(__assign({}, affordabilityErrors), payErrors);
};
exports.validateLoanAffordabilityStep = validateLoanAffordabilityStep;
// Validation for Employment Details (Step 3 - Part 1)
var validateEmploymentDetails = function (employmentStatus, monthlyIncome, employer, supervisorName, workNumber, departmentNumber, workplaceAddress, employeeNumber, appointmentDate) {
    var errors = {};
    // Employment Status validation
    if (!employmentStatus) {
        errors.employmentStatus = "Please select employment status";
    }
    // Monthly Income validation
    if (!monthlyIncome.trim() || (0, input_validators_1.isWhitespaceOnly)(monthlyIncome)) {
        errors.monthlyIncome = "Please enter your monthly income";
    }
    else if (!(0, input_validators_1.isValidDecimal)(monthlyIncome, 2)) {
        errors.monthlyIncome = "Please enter a valid number (max 2 decimal places)";
    }
    else if (!(0, input_validators_1.isPositiveNumber)(monthlyIncome)) {
        errors.monthlyIncome = "Monthly income must be greater than 0";
    }
    // Employment Details validation (only if employed)
    var isEmployed = [
        "Permanent",
        "Contract",
        "Temporary",
        "permanent",
        "contract",
        "temporary",
    ].includes(employmentStatus);
    if (isEmployed) {
        if (!employer.trim() || (0, input_validators_1.isWhitespaceOnly)(employer)) {
            errors.employer = "Please enter your employer";
        }
        if (!supervisorName.trim() || (0, input_validators_1.isWhitespaceOnly)(supervisorName)) {
            errors.supervisorName = "Please enter supervisor name";
        }
        if (!workNumber.phone_number.trim()) {
            errors.workNumber = "Please enter work number";
        }
        else {
            var lengthError = (0, phone_utils_1.getPhoneLengthError)(workNumber, "Work number");
            if (lengthError) {
                errors.workNumber = lengthError;
            }
        }
        // Department number and employee number are optional
        if (!workplaceAddress.trim() || (0, input_validators_1.isWhitespaceOnly)(workplaceAddress)) {
            errors.workplaceAddress = "Please enter workplace address";
        }
        if (appointmentDate !== undefined &&
            (!appointmentDate.trim() || (0, input_validators_1.isWhitespaceOnly)(appointmentDate))) {
            errors.appointmentDate = "Please select your start date";
        }
    }
    return errors;
};
exports.validateEmploymentDetails = validateEmploymentDetails;
// Validation for Paypoint Details (Step 3 - Part 2)
var validatePaypointDetails = function (paymasterName, payPointPhoneNumber, payPointPostalAddress, postalCode, payPointPhysicalAddress) {
    var errors = {};
    if (!paymasterName.trim()) {
        errors.paymasterName = "Please enter paymaster name";
    }
    if (!payPointPhoneNumber.phone_number.trim()) {
        errors.payPointPhoneNumber = "Please enter pay point phone number";
    }
    else {
        var lengthError = (0, phone_utils_1.getPhoneLengthError)(payPointPhoneNumber, "Pay point phone number");
        if (lengthError) {
            errors.payPointPhoneNumber = lengthError;
        }
    }
    // Client update: postal address and code are optional for paypoint capture.
    if (!payPointPhysicalAddress.trim()) {
        errors.payPointPhysicalAddress = "Please enter pay point physical address";
    }
    return errors;
};
exports.validatePaypointDetails = validatePaypointDetails;
// Combined validation for Step 3: Employment & Pay Point
var validateEmploymentPaypointStep = function (employmentStatus, monthlyIncome, employer, supervisorName, workNumber, departmentNumber, workplaceAddress, employeeNumber, paymasterName, payPointPhoneNumber, payPointPostalAddress, postalCode, payPointPhysicalAddress, payDate) {
    var employmentErrors = (0, exports.validateEmploymentDetails)(employmentStatus, monthlyIncome, employer, supervisorName, workNumber, departmentNumber, workplaceAddress, employeeNumber);
    var paypointErrors = (0, exports.validatePaypointDetails)(paymasterName, payPointPhoneNumber, payPointPostalAddress, postalCode, payPointPhysicalAddress);
    var combined = __assign(__assign({}, employmentErrors), paypointErrors);
    if (["permanent", "contract", "temporary"].includes(employmentStatus)) {
        if (!payDate.trim()) {
            combined.payDate = "Please select your pay date";
        }
    }
    return combined;
};
exports.validateEmploymentPaypointStep = validateEmploymentPaypointStep;
// Validation for Banking Details (Step 4 - Part 1)
var validateBankingDetails = function (selectedBank, bankBranch, accountNumber, accountType) {
    var errors = {};
    if (!selectedBank) {
        errors.selectedBank = "Please select a bank";
    }
    if (!bankBranch.trim() || (0, input_validators_1.isWhitespaceOnly)(bankBranch)) {
        errors.bankBranch = "Please enter bank branch";
    }
    if (!accountNumber.trim() || (0, input_validators_1.isWhitespaceOnly)(accountNumber)) {
        errors.accountNumber = "Please enter account number";
    }
    else if (!(0, input_validators_1.isNumericOnly)(accountNumber)) {
        errors.accountNumber = "Account number must contain only numbers";
    }
    if (!accountType) {
        errors.accountType = "Please select account type";
    }
    return errors;
};
exports.validateBankingDetails = validateBankingDetails;
// Validation for Documents (Step 4 - Part 2)
var validateDocuments = function (latestPayslipFile, bankStatementFiles, existingPayslipUrl, existingBankStatementUrls) {
    var errors = {};
    // Check for payslip (either new file or existing URL)
    var hasPayslip = latestPayslipFile || (existingPayslipUrl && existingPayslipUrl.length > 0);
    // Check for bank statements (either new files or existing URLs)
    var hasBankStatements = (bankStatementFiles && bankStatementFiles.length > 0) ||
        (existingBankStatementUrls && existingBankStatementUrls.length > 0);
    // Provide specific error messages for each document type
    if (!hasPayslip) {
        errors.payslip = validation_messages_1.DOCUMENTS_ERRORS.PAYSLIP_REQUIRED;
    }
    if (!hasBankStatements) {
        errors.bankStatements = validation_messages_1.DOCUMENTS_ERRORS.BANK_STATEMENTS_REQUIRED;
    }
    // If both are missing, also add a general documents error
    if (!hasPayslip && !hasBankStatements) {
        errors.documents = validation_messages_1.DOCUMENTS_ERRORS.AT_LEAST_ONE_REQUIRED;
    }
    return errors;
};
exports.validateDocuments = validateDocuments;
// Combined validation for Step 4: Banking & Documents
var validateBankingDocumentsStep = function (selectedBank, bankBranch, accountNumber, accountType, latestPayslipFile, bankStatementFiles) {
    var bankingErrors = (0, exports.validateBankingDetails)(selectedBank, bankBranch, accountNumber, accountType);
    var documentErrors = (0, exports.validateDocuments)(latestPayslipFile, bankStatementFiles);
    return __assign(__assign({}, bankingErrors), documentErrors);
};
exports.validateBankingDocumentsStep = validateBankingDocumentsStep;
// Validation for Salary Deduction Agreement (Step 5 - Part 1, conditional on employment)
var validateSalaryDeductionAgreement = function (employmentStatus, lender, yourEmployer, signedDocumentUrl) {
    var errors = {};
    // Only validate if user is employed
    if (["permanent", "contract", "temporary"].includes(employmentStatus)) {
        if (!lender.trim()) {
            errors.lender = "Please enter lender name";
        }
        if (!yourEmployer.trim()) {
            errors.yourEmployer = "Please enter your employer name";
        }
        if (!signedDocumentUrl.trim()) {
            errors.signedDocumentUrl = "Please provide your digital signature";
        }
    }
    return errors;
};
exports.validateSalaryDeductionAgreement = validateSalaryDeductionAgreement;
// Validation for Agreements (Step 5)
var validateAgreements = function (bankSignatureURL, confirmationChecked, employmentStatus, lender, yourEmployer, signedDocumentUrl) {
    var errors = {};
    // Salary Deduction Agreement validation (only if employed)
    var salaryDeductionErrors = (0, exports.validateSalaryDeductionAgreement)(employmentStatus, lender, yourEmployer, signedDocumentUrl);
    // Bank Debit Authorization validation (always required)
    if (!bankSignatureURL) {
        errors.bankSignatureURL =
            "Please provide bank debit authorization signature";
    }
    // Confirmation checkbox validation (always required)
    if (!confirmationChecked) {
        errors.confirmation =
            "Please confirm that all information provided is accurate and complete";
    }
    return __assign(__assign({}, salaryDeductionErrors), errors);
};
exports.validateAgreements = validateAgreements;
